var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"margin-top":"100px"}},[_c('el-col',{attrs:{"sm":24,"lg":6}},[_c('el-result',{attrs:{"icon":"success","title":"扫码成功","subTitle":"请等待web页面跳转或提示"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }